import React, { useMemo } from 'react';
import { Text } from '@spothero/ui';
import { getSpotheroOversizeFee, OversizeType, } from 'utils/search-vehicle';
import { useSelector } from 'react-redux';
import { getSpotById, getVehicleInfo } from 'store/spots/spots-selectors';
import useOversizeEnabled from 'hooks/use-oversize-enabled';
const ConditionalOversizeOnSite = ({ spotId }) => {
    const isOversizeEnabled = useOversizeEnabled();
    const vehicle = useSelector(getVehicleInfo);
    const selectedSpot = useSelector(getSpotById(spotId));
    const oversizeFee = useMemo(() => (selectedSpot ? getSpotheroOversizeFee(selectedSpot) : null), [selectedSpot]);
    const supportsOversizeFee = oversizeFee?.type === OversizeType.ChargedOnsiteKnown;
    return supportsOversizeFee && isOversizeEnabled ? (<Text fontSize="xs" color="text.secondary.light" paddingTop={2}>
            An oversize fee may apply for {vehicle?.display_make}{' '}
            {vehicle?.display_model}, pay the ${oversizeFee?.dollars} fee
            directly onsite.
        </Text>) : null;
};
export { ConditionalOversizeOnSite };
